<template>
    <v-container fluid>
        <v-dialog persistent v-model="bankAccountDialog" width="600">
            <v-card>
                <v-card-title>
                    {{ bankAccount.name }}
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <v-row dense wrap>
                                <v-col cols="12">
                                    <InputField
                                        :maxlength="50"
                                        v-model="bankAccount.name"
                                        :errorBorder="!bankAccountValidation.name"
                                        :label="'* ' + $t('fields.name')"
                                    ></InputField>
                                </v-col>
                                <v-col cols="12">
                                    <InputField
                                        :maxlength="10"
                                        v-model="bankAccount.swift_code"
                                        :errorBorder="!bankAccountValidation.swift_code"
                                        :label="'* ' + $t('fields.swiftCode')"
                                    ></InputField>
                                </v-col>
                                <v-col cols="12">
                                    <InputField
                                        :maxlength="20"
                                        v-model="bankAccount.bank_name"
                                        :errorBorder="!bankAccountValidation.bank_name"
                                        :label="'* ' + $t('fields.bankName')"
                                    ></InputField>
                                </v-col>
                                <v-col cols="12">
                                    <InputField
                                        :maxlength="50"
                                        v-model="bankAccount.bank_address"
                                        :errorBorder="!bankAccountValidation.bank_address"
                                        :label="'* ' + $t('fields.bankAddress')"
                                    ></InputField>
                                </v-col>
                                <v-col cols="12">
                                    <InputField
                                        :maxlength="20"
                                        v-model="bankAccount.bank_post_code"
                                        :errorBorder="!bankAccountValidation.bank_post_code"
                                        :label="'* ' + $t('fields.bankPostCode')"
                                    ></InputField>
                                </v-col>
                                <v-col cols="12">
                                    <InputField
                                        :maxlength="20"
                                        v-model="bankAccount.bank_town"
                                        :errorBorder="!bankAccountValidation.bank_town"
                                        :label="'* ' + $t('fields.bankTown')"
                                    ></InputField>
                                </v-col>
                                <v-col cols="12">
                                    <Dropdown2
                                        :readonly="!inEditMode"
                                        v-model="bankAccount.country_id"
                                        :ajax="true"
                                        :data="'countries'"
                                        :errorBorder="!bankAccountValidation.country_id"
                                        :label="'* ' + $t('fields.country')"
                                    ></Dropdown2>
                                </v-col>
                                <v-col cols="12">
                                    <InputField
                                        :maxlength="10"
                                        v-model="bankAccount.bic"
                                        :errorBorder="!bankAccountValidation.bic"
                                        :label="'* ' + $t('fields.bic')"
                                    ></InputField>
                                </v-col>
                                <v-col cols="12">
                                    <InputField
                                        :maxlength="20"
                                        v-model="bankAccount.account_holder_name"
                                        :errorBorder="!bankAccountValidation.account_holder_name"
                                        :label="'* ' + $t('fields.accountHolderName')"
                                    ></InputField>
                                </v-col>
                                <v-col cols="12">
                                    <InputField
                                        :maxlength="34"
                                        v-model="bankAccount.iban"
                                        :errorBorder="!bankAccountValidation.iban"
                                        :label="'* ' + $t('fields.iban')"
                                    ></InputField>
                                </v-col>
                                <v-col cols="12">
                                    <Dropdown
                                        :readonly="!inEditMode"
                                        v-model="bankAccount.currency_id"
                                        :ajax="true"
                                        :data="'currencies'"
                                        :errorBorder="!bankAccountValidation.currency_id"
                                        :label="'* ' + $t('fields.currency')"
                                    ></Dropdown>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col
                                    cols="12"
                                    md="6"
                                    class="text-right"
                                    :class="{'text-center': $vuetify.breakpoint.smAndDown}"
                                >
                                    <v-btn color="primary" class="white--text" @click.stop="saveChanges"
                                        >{{ $t('buttons.save') }}
                                    </v-btn>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="6"
                                    class="text-left"
                                    :class="{'text-center': $vuetify.breakpoint.smAndDown}"
                                >
                                    <v-btn color="secondary" class="white--text" @click.stop="closeDialog"
                                        >{{ $t('buttons.cancel') }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-row>
            <v-col class="pl-1">
                <v-btn v-if="inEditMode" class="ml-2 mr-2" color="primary" @click="saveClick(false)">
                    <v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
                </v-btn>
                <v-btn v-if="inEditMode" class="ml-2 mr-2" color="primary" @click="saveClick(true)">
                    <v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.saveAndExit') }}
                </v-btn>
                <v-btn v-if="!inEditMode" class="ml-2 mr-2" color="primary" @click="editClick()">
                    <v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
                </v-btn>
                <v-btn class="mr-2" @click="backClick">
                    <v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" xl="5" lg="5" md="7">
                <v-row dense wrap>
                    <v-col cols="6">
                        <InputField
                            :readonly="true"
                            v-model="internalOffice.id"
                            :label="'* ' + $t('fields.id')"
                        ></InputField>
                    </v-col>
                    <v-col cols="6" class="pt-0">
                        <CheckBox
                            :readonly="!inEditMode"
                            v-model="internalOffice.active"
                            :label="$t('fields.active')"
                        ></CheckBox>
                    </v-col>
                    <v-col cols="12">
                        <InputField
                            :maxlength="50"
                            :readonly="!inEditMode"
                            v-model="internalOffice.name"
                            :errorBorder="!internalOfficeValidation.name"
                            :label="'* ' + $t('fields.name')"
                        ></InputField>
                    </v-col>
                    <v-col cols="12">
                        <InputField
                            :maxlength="50"
                            :readonly="!inEditMode"
                            v-model="internalOffice.address"
                            :errorBorder="!internalOfficeValidation.address"
                            :label="'* ' + $t('fields.address')"
                        ></InputField>
                    </v-col>
                    <v-col cols="12">
                        <InputField
                            :maxlength="10"
                            :readonly="!inEditMode"
                            v-model="internalOffice.postcode"
                            :errorBorder="!internalOfficeValidation.postcode"
                            :label="'* ' + $t('fields.postalCode')"
                        ></InputField>
                    </v-col>
                    <v-col cols="12">
                        <InputField
                            :maxlength="20"
                            :readonly="!inEditMode"
                            v-model="internalOffice.town"
                            :errorBorder="!internalOfficeValidation.town"
                            :label="'* ' + $t('fields.town')"
                        ></InputField>
                    </v-col>
                    <v-col cols="12">
                        <Dropdown2
                            :readonly="!inEditMode"
                            v-model="internalOffice.country_id"
                            :ajax="true"
                            :data="'countries'"
                            :errorBorder="!internalOfficeValidation.country_id"
                            :label="'* ' + $t('fields.country')"
                        ></Dropdown2>
                    </v-col>
                    <v-col cols="12">
                        <InputField
                            :maxlength="11"
                            :readonly="!inEditMode"
                            v-model="internalOffice.oib"
                            :errorBorder="!internalOfficeValidation.oib"
                            :label="'* ' + $t('fields.oib')"
                        ></InputField>
                    </v-col>
                    <v-col cols="12">
                        <TextArea
                            :maxlength="500"
                            :readonly="!inEditMode"
                            v-model="internalOffice.notes"
                            :errorBorder="!internalOfficeValidation.notes"
                            :label="'* ' + $t('fields.notes')"
                        ></TextArea>
                    </v-col>
                    <v-col cols="12">
                        <TextArea
                            :maxlength="500"
                            :readonly="!inEditMode"
                            v-model="internalOffice.office_footer"
                            :errorBorder="!internalOfficeValidation.office_footer"
                            :label="'* ' + $t('fields.officeFooter')"
                        ></TextArea>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" xl="5" lg="7" md="5">
                <v-row dense wrap>
                    <v-col cols="12">
                        <InputField
                            :maxlength="20"
                            :readonly="!inEditMode"
                            v-model="internalOffice.phone"
                            :errorBorder="!internalOfficeValidation.phone"
                            :label="'* ' + $t('fields.phone')"
                        ></InputField>
                    </v-col>
                    <v-col cols="12">
                        <InputField
                            :maxlength="20"
                            :readonly="!inEditMode"
                            v-model="internalOffice.fax"
                            :errorBorder="!internalOfficeValidation.fax"
                            :label="'* ' + $t('fields.fax')"
                        ></InputField>
                    </v-col>
                    <v-col cols="12">
                        <InputField
                            :maxlength="15"
                            :readonly="!inEditMode"
                            v-model="internalOffice.vat"
                            :errorBorder="!internalOfficeValidation.vat"
                            :label="'* ' + $t('fields.vat')"
                        ></InputField>
                    </v-col>
                    <v-col cols="12">
                        <InputField
                            :maxlength="50"
                            :readonly="!inEditMode"
                            v-model="internalOffice.email"
                            :errorBorder="!internalOfficeValidation.email"
                            :label="'* ' + $t('fields.email')"
                        ></InputField>
                    </v-col>
                    <v-col>
                        <h4>
                            {{ $t('labels.officeLogo') }}
                        </h4>
                    </v-col>

                    <v-col cols="12">
                        <Upload
                            :readonly="!inEditMode"
                            v-model="internalOffice.logo"
                            :errorBorder="!internalOfficeValidation.logo"
                        ></Upload>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" xl="4" lg="7" md="5">
                <v-row>
                    <v-col>
                        <h4>
                            {{ $t('labels.accounts') }}
                        </h4>
                    </v-col>
                </v-row>
                <v-col>
                    <v-data-table
                        :items="internalOfficeBankAccounts"
                        fixed-header
                        dense
                        class="row-item"
                        :hide-default-footer="true"
                    >
                        <template v-slot:item="row">
                            <tr>
                                <td>
                                    {{ row.item.name }}
                                </td>
                                <td>
                                    {{ row.item.account_holder_name }}
                                </td>
                                <td v-if="inEditMode">
                                    <v-icon @click="editBankAccount(row.item)" small color="black">fas fa-edit</v-icon>
                                </td>
                            </tr></template
                        >
                    </v-data-table>
                </v-col>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import CheckBox from './trinkets/CheckBox';
import Dropdown from './trinkets/Dropdown';
import Dropdown2 from './trinkets/Dropdown2';
import InputField from './trinkets/InputField';
import InternalOffice from '../models/InternalOffice';
import InternalOfficeBankAccount from '../models/InternalOfficeBankAccount';
import TextArea from './trinkets/TextArea';
import Upload from './trinkets/UploadImage';

export default {
    name: 'InternalOffice',
    components: {
        CheckBox,
        Dropdown,
        Dropdown2,
        InputField,
        TextArea,
        Upload,
    },
    data: function () {
        return {
            bankAccountDialog: false,
            internalOffice: new InternalOffice({id: this.$route.params.id}),
            internalOfficeValidation: new InternalOffice({}, true),
            initialLoad: false,
            inEditMode: false,
            lockKey: 'internal-office',
            lockTimer: null,
            internalOfficeBankAccounts: [],
            bankAccount: new InternalOfficeBankAccount({}),
            bankAccountValidation: new InternalOfficeBankAccount({}, true),
        };
    },
    watch: {
        'internalOffice.logo': {
            handler: function () {
                var ext = this.internalOffice.logo.original_name.split('.').pop();
                if (!(ext == 'png' || ext == '')) {
                    this.internalOffice.logo.name = '';
                    this.internalOffice.logo.link = '';
                    this.internalOffice.logo.original_name = '';
                    this.internalOffice.logo.upload_id = null;
                    this.$alert(this.$t('alerts.onlyPng'));
                }
            },
            deep: true,
        },
    },
    methods: {
        closeDialog() {
            this.bankAccount = new InternalOfficeBankAccount({});
            this.bankAccountDialog = false;
        },
        editBankAccount(account) {
            this.bankAccountDialog = true;
            this.bankAccount = {...account};
        },
        editClick() {
            let vm = this;
            this.$setLock(this, this.lockKey + '|' + this.internalOffice.id, (data) => {
                if (data.success) {
                    vm.inEditMode = true;
                    vm.lockTimer = setInterval(() => {
                        vm.$setLock(vm, vm.lockKey + '|' + vm.internalOffice.id);
                    }, 10000);
                } else {
                    vm.$alert(
                        this.$t('alerts.recordLocked')
                            .split('%name%')
                            .join(data.locked_by.first_name + ' ' + data.locked_by.last_name),
                    );
                }
            });
        },
        saveChanges() {
            let success = true;
            let missingFields = '';
            if (this.bankAccount.name == '') {
                success = false;
                missingFields += this.$t('fields.name') + '<br/>';
                this.bankAccountValidation.name = false;
            } else {
                this.bankAccountValidation.name = true;
            }
            if (this.bankAccount.swift_code == '') {
                success = false;
                this.bankAccountValidation.swift_code = false;
            } else {
                this.bankAccountValidation.swift_code = true;
            }
            if (this.bankAccount.bank_name == '') {
                success = false;
                this.bankAccountValidation.bank_name = false;
            } else {
                this.bankAccountValidation.bank_name = true;
            }
            if (this.bankAccount.bank_address == '') {
                success = false;
                this.bankAccountValidation.bank_address = false;
            } else {
                this.bankAccountValidation.bank_address = true;
            }
            if (this.bankAccount.bank_post_code == '') {
                success = false;
                this.bankAccountValidation.bank_post_code = false;
            } else {
                this.bankAccountValidation.bank_post_code = true;
            }
            if (this.bankAccount.bank_town == '') {
                success = false;
                this.bankAccountValidation.bank_town = false;
            } else {
                this.bankAccountValidation.bank_town = true;
            }
            if (this.bankAccount.country_id == '' || this.bankAccount.country_id == null) {
                success = false;
                this.bankAccountValidation.country_id = false;
            } else {
                this.bankAccountValidation.country_id = true;
            }
            if (this.bankAccount.bic == '') {
                success = false;
                this.bankAccountValidation.bic = false;
            } else {
                this.bankAccountValidation.bic = true;
            }
            if (this.bankAccount.account_holder_name == '') {
                success = false;
                this.bankAccountValidation.account_holder_name = false;
            } else {
                this.bankAccountValidation.account_holder_name = true;
            }
            if (this.bankAccount.iban == '') {
                success = false;
                this.bankAccountValidation.iban = false;
            } else {
                this.bankAccountValidation.iban = true;
            }
            if (this.bankAccount.currency_id == '' || this.bankAccount.currency_id == null) {
                success = false;
                this.bankAccountValidation.currency_id = false;
            } else {
                this.bankAccountValidation.currency_id = true;
            }
            if (success) {
                let vm = this;
                let action = 'post';
                let addition = '';
                if (vm.bankAccount.id != 0) {
                    action = 'put';
                    addition = '/' + vm.bankAccount.id;
                }
                this.$APICall(action, 'internal-office-bank-accounts' + addition, this.bankAccount, (data, success) => {
                    if (success) {
                        if (vm.bankAccount.id == 0) {
                            vm.closeDialog();
                            vm.$APICall(
                                'get',
                                'internal-office-bank-accounts/' + this.internalOffice.id,
                                {},
                                (data, success) => {
                                    if (success) {
                                        let usableData = JSON.parse(JSON.stringify(data));
                                        vm.internalOfficeBankAccounts = usableData;
                                    }
                                },
                            );
                            vm.$notify(vm.$t('alerts.basicAdd'));
                        } else {
                            vm.closeDialog();
                            vm.$APICall(
                                'get',
                                'internal-office-bank-accounts/' + this.internalOffice.id,
                                {},
                                (data, success) => {
                                    if (success) {
                                        let usableData = JSON.parse(JSON.stringify(data));
                                        vm.internalOfficeBankAccounts = usableData;
                                    }
                                },
                            );
                            vm.$notify(vm.$t('alerts.basicUpdate'));
                        }
                    } else {
                        vm.$notify(vm.$t('alerts.basicError'));
                    }
                });
            } else {
                let alert = 'Missing fields: <br />' + missingFields;
                this.$alert(alert);
            }
        },
        backClick() {
            this.$router.go(-1);
        },
        saveClick(goBack) {
            let success = true;
            let alert = '';
            if (this.internalOffice.name == '') {
                success = false;
                this.internalOfficeValidation.name = false;
                alert += this.$t('fields.name') + '<br/>';
            } else {
                this.internalOfficeValidation.name = true;
            }
            if (this.internalOffice.address == '') {
                success = false;
                this.internalOfficeValidation.address = false;
                alert += this.$t('fields.address') + '<br/>';
            } else {
                this.internalOfficeValidation.address = true;
            }
            if (this.internalOffice.postcode == '') {
                success = false;
                this.internalOfficeValidation.postcode = false;
                alert += this.$t('fields.postalCode') + '<br/>';
            } else {
                this.internalOfficeValidation.postcode = true;
            }
            if (this.internalOffice.town == '') {
                success = false;
                this.internalOfficeValidation.town = false;
                alert += this.$t('fields.town') + '<br/>';
            } else {
                this.internalOfficeValidation.town = true;
            }
            if (this.internalOffice.country_id == '' || this.internalOffice.country_id == null) {
                success = false;
                this.internalOfficeValidation.country_id = false;
                alert += this.$t('fields.country') + '<br/>';
            } else {
                this.internalOfficeValidation.country_id = true;
            }
            if (!this.$checkOIB(this.internalOffice.oib)) {
                success = false;
                alert += this.$t('alerts.oibFormattFailed') + '<br/>';
                this.internalOfficeValidation.oib = false;
            } else {
                this.internalOfficeValidation.oib = true;
            }
            if (this.internalOffice.phone == '') {
                success = false;
                this.internalOfficeValidation.phone = false;
                alert += this.$t('fields.phone') + '<br/>';
            } else {
                this.internalOfficeValidation.phone = true;
            }
            if (this.internalOffice.fax == '') {
                success = false;
                this.internalOfficeValidation.fax = false;
                alert += this.$t('fields.fax') + '<br/>';
            } else {
                this.internalOfficeValidation.fax = true;
            }
            if (this.internalOffice.vat.length < 4 || this.internalOffice.vat.length > 15) {
                success = false;
                this.internalOfficeValidation.vat = false;
                alert += this.$t('alerts.vatLength') + '<br/>';
            } else {
                this.internalOfficeValidation.vat = true;
            }
            if (!this.$checkEmail(this.internalOffice.email)) {
                success = false;
                this.internalOfficeValidation.email = false;
                alert += this.$t('alerts.emailFailFormat') + '<br/>';
            } else {
                this.internalOfficeValidation.email = true;
            }
            if (this.internalOffice.logo.name == '') {
                success = false;
                alert += this.$t('alerts.logoMissing');
            }

            if (success && alert == '') {
                let vm = this;
                let action = 'post';
                let addition = '';
                if (vm.internalOffice.id != 0) {
                    action = 'put';
                    addition = '/' + vm.internalOffice.id;
                }
                this.$APICall(action, 'internal-offices' + addition, this.internalOffice, (data, success) => {
                    if (success) {
                        vm.inEditMode = false;
                        if (vm.internalOffice.id == 0) {
                            vm.$notify(vm.$t('alerts.basicAdd'));
                        } else {
                            vm.$notify(vm.$t('alerts.basicUpdate'));
                        }
                        if (this.lockTimer !== null) clearInterval(this.lockTimer);
                        vm.$removeLock(vm, vm.lockKey + '|' + vm.internalOffice.id);
                        vm.$triggerReload();
                        if (goBack) {
                            vm.backClick();
                        }
                    }
                });
            } else if (alert != '') {
                let missing = 'Missing fields: <br/> ' + alert;
                this.$alert(missing);
            }
        },
    },
    beforeRouteLeave(to, from, next) {
        if (this.inEditMode) {
            let vm = this;
            this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
                if (result) {
                    if (vm.lockTimer !== null) clearInterval(vm.lockTimer);
                    vm.$removeLock(vm, vm.lockKey + '|' + vm.internalOffice.id);
                    next(true);
                } else {
                    next(false);
                }
            });
        } else {
            next(true);
        }
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        let vm = this;
        if (this.internalOffice.id != 0) {
            this.$APICall('get', 'internal-offices/' + this.internalOffice.id, {}, (data, success) => {
                if (success) {
                    let usableData = JSON.parse(JSON.stringify(data));
                    vm.internalOffice = usableData;
                    vm.$myStore.commit('setBreadcrumbs', [
                        {
                            text: vm.$t('modules.internalOffices'),
                            href: '/#/internal-offices',
                            disabled: false,
                        },
                        {
                            text: vm.internalOffice.name,
                            href: '/#/internal-offices/' + vm.internalOffice.id,
                            disabled: true,
                        },
                    ]);
                    vm.$nextTick(() => {
                        vm.initialLoad = true;
                    });
                }
            });
            this.$APICall('get', 'internal-office-bank-accounts/' + this.internalOffice.id, {}, (data, success) => {
                if (success) {
                    let usableData = JSON.parse(JSON.stringify(data));
                    vm.internalOfficeBankAccounts = usableData;
                }
            });
        } else {
            this.$myStore.commit('setBreadcrumbs', [
                {
                    text: this.$t('modules.internalOffices'),
                    href: '/#/internal-offices',
                    disabled: false,
                },
                {
                    text: this.$t('modules.newInternalOffice'),
                    href: '/#/internal-offices/0',
                    disabled: true,
                },
            ]);
            this.inEditMode = true;
            this.initialLoad = true;
        }
    },
};
</script>

<style scoped></style>
